import React, { FunctionComponent, useState } from 'react';
import Modal from '@justgiving/modal';
import CopyToClipboard from '@justgiving/copy-to-clipboard';
import { Trans } from 'react-i18next';
import { Button } from '@justgiving/react-tracking';

import MessengerShare from '../SocialButtons/MessengerShare';
import EmailShare from '../SocialButtons/EmailShare';

import '@justgiving/modal/src/Modal.scss';
import { withTrack, WithTrack } from '../../utils/analytics';
import { usePageMeta } from '../../hooks';

type InviteMembersModalProps = WithTrack & {
  isModalOpen: boolean;
  onCloseModal: () => any;
};

const trackingData = { page_section: 'invite team members' };

export const InviteMembersModal: FunctionComponent<InviteMembersModalProps> = ({
  isModalOpen,
  onCloseModal,
  track,
}) => {
  const [copiedToClipboard, setCopiedToClipboard] = useState(false);
  const { currentUrl } = usePageMeta();

  function copyToClipBoard() {
    track({
      ...trackingData,
      event_value: 'copy link',
    });
    setCopiedToClipboard(true);
  }

  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={onCloseModal}
      classNames="jg-pages-modal"
    >
      <h1 className="jg-h1 jg-space-mtmd jg-space-mblg jg-text--center">
        <Trans i18nKey="members.invite">Invite team members</Trans>
      </h1>
      <ul className="jg-list--unstyled">
        <li className="jg-space-mbmd">
          <MessengerShare trackingData={trackingData} />
        </li>
        <li className="jg-space-mbmd">
          <EmailShare trackingData={trackingData} />
        </li>
        <li className="jg-space-mblg">
          <CopyToClipboard
            text={`${currentUrl}?invite=true`}
            copyMessage={<Trans i18nKey="common.copyLink">Copy link</Trans>}
            copiedMessage={
              <Trans i18nKey="common.linkCopied">Copied to clipboard</Trans>
            }
            copied={copiedToClipboard}
            onCopy={copyToClipBoard}
          />
        </li>
        <li>
          <Button
            className="jg-btn jg-btn--ghost"
            onClick={onCloseModal}
            type="button"
            data-qa="invite-modal-close"
            trackingData={{
              event: 'link click',
              action_name: 'link click',
              subtype: 'button',
              event_value: 'go to my team page',
              ...trackingData,
            }}
          >
            <Trans i18nKey="common.cancel">Cancel</Trans>
          </Button>
        </li>
      </ul>
    </Modal>
  );
};

export default withTrack(InviteMembersModal);
